import geoIcon from "../../assets/geo.svg";

class MapService {
  map: google.maps.Map | undefined;
  markers: [];

  init(element: HTMLElement, options: google.maps.MapOptions) {
    if (this.map) return;
    this.map = new google.maps.Map(element, {
      zoom: 10,
      center: new google.maps.LatLng(65, 65),
      zoomControl: true,
      styles: [
        {
          featureType: "poi",
          elementType: "labels",
          stylers: [
            { visibility: "off" },
          ],
        },
      ],
      ...options,
    });
    return this;
  }

  clear = () => this.map = undefined;

  panTo(coords: google.maps.LatLng, onBottom = false) {
    if (!this.map) return;
    this.map.panTo(coords);
    this.map.setZoom(15);
    if (onBottom)
      this.map.panBy(0, -1 * (window.innerHeight / 3));
  }

  updateMarkers(stores, clickBack) {
    if (!this.map || stores.length === this.markers) return;
    stores.forEach((store: any) => {
      const marker = new google.maps.Marker({
        position: new google.maps.LatLng(store.coords[0], store.coords[1]),
        title: store.name,
        map: mapService.getInstance(),
        icon: {
          url: geoIcon,
          size: new google.maps.Size(32, 32),
          scaledSize: new google.maps.Size(32, 32),
        },
      });
      marker.addListener("click", () => {
        // @ts-ignore
        mapService.panTo(marker.getPosition(), true);
        //clickBack(store);
      });
    });
  }

  getInstance(): google.maps.Map {
    return this.map;
  }
}

export const mapService = new MapService();
